import { useContext } from "react";
import { AppContextContext } from "../context";
import AppStateManager from "../managers/AppStateManager";
export default () => {
  const context = useContext(AppContextContext);
  return AppStateManager.getInstance(context);
};